import { render, staticRenderFns } from "./receive.vue?vue&type=template&id=cb3c81bc&scoped=true&"
import script from "./receive.vue?vue&type=script&lang=js&"
export * from "./receive.vue?vue&type=script&lang=js&"
import style0 from "./receive.vue?vue&type=style&index=0&id=cb3c81bc&prod&lang=less&scoped=true&"
import style1 from "./receive.vue?vue&type=style&index=1&id=cb3c81bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3c81bc",
  null
  
)

export default component.exports